import script from "./link-list.vue?vue&type=script&lang=js"
export * from "./link-list.vue?vue&type=script&lang=js"

import "./link-list.vue?vue&type=style&index=0&id=65ab2142&lang=scss"

const __exports__ = script;

export default __exports__